import axios from "axios";

// Module-level cache — fetched once per browser session
let cache = null;
let pending = null;

// Returns { [form_key]: form_num } e.g. { MATERIAL_REQUEST: 'F-QP-STR-01-01 Rev.03' }
export function fetchFormNos() {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = axios
      .get("https://eps.elkomprintama.com/get/api/formno", {
        withCredentials: true,
      })
      .then((res) => {
        cache = {};
        (res.data.result || []).forEach((r) => {
          if (r.form_key) cache[r.form_key] = r.form_num;
        });
        return cache;
      })
      .catch(() => {
        pending = null;
        return {};
      });
  }
  return pending;
}

// Call this after any update from the management page so the next fetch is fresh
export function invalidateFormNosCache() {
  cache = null;
  pending = null;
}
